/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/AgendaTimeSerieEvent'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./AgendaTimeSerieEvent'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.AgendaTimeSerieRuleReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.AgendaTimeSerieEvent);
  }
}(this, function(ApiClient, AgendaTimeSerieEvent) {
  'use strict';




  /**
   * The AgendaTimeSerieRuleReport model module.
   * @module model/AgendaTimeSerieRuleReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>AgendaTimeSerieRuleReport</code>.
   * @alias module:model/AgendaTimeSerieRuleReport
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>AgendaTimeSerieRuleReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AgendaTimeSerieRuleReport} obj Optional instance to populate.
   * @return {module:model/AgendaTimeSerieRuleReport} The populated <code>AgendaTimeSerieRuleReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Events')) {
        obj['Events'] = ApiClient.convertToType(data['Events'], [AgendaTimeSerieEvent]);
      }
      if (data.hasOwnProperty('TimeReservationID')) {
        obj['TimeReservationID'] = ApiClient.convertToType(data['TimeReservationID'], 'Integer');
      }
      if (data.hasOwnProperty('IntervalPeriodTypeID')) {
        obj['IntervalPeriodTypeID'] = ApiClient.convertToType(data['IntervalPeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('IntervalPeriodDay')) {
        obj['IntervalPeriodDay'] = ApiClient.convertToType(data['IntervalPeriodDay'], 'Integer');
      }
      if (data.hasOwnProperty('IntervalStartDate')) {
        obj['IntervalStartDate'] = ApiClient.convertToType(data['IntervalStartDate'], 'Date');
      }
      if (data.hasOwnProperty('ItemCreationDayOffset')) {
        obj['ItemCreationDayOffset'] = ApiClient.convertToType(data['ItemCreationDayOffset'], 'Integer');
      }
      if (data.hasOwnProperty('NotifyCreator')) {
        obj['NotifyCreator'] = ApiClient.convertToType(data['NotifyCreator'], 'Boolean');
      }
      if (data.hasOwnProperty('LastGeneratedPeriod')) {
        obj['LastGeneratedPeriod'] = ApiClient.convertToType(data['LastGeneratedPeriod'], 'Date');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/AgendaTimeSerieEvent>} Events
   */
  exports.prototype['Events'] = undefined;
  /**
   * @member {Integer} TimeReservationID
   */
  exports.prototype['TimeReservationID'] = undefined;
  /**
   * @member {Integer} IntervalPeriodTypeID
   * @default 0
   */
  exports.prototype['IntervalPeriodTypeID'] = 0;
  /**
   * @member {Integer} IntervalPeriodDay
   * @default 0
   */
  exports.prototype['IntervalPeriodDay'] = 0;
  /**
   * @member {Date} IntervalStartDate
   */
  exports.prototype['IntervalStartDate'] = undefined;
  /**
   * @member {Integer} ItemCreationDayOffset
   * @default 0
   */
  exports.prototype['ItemCreationDayOffset'] = 0;
  /**
   * @member {Boolean} NotifyCreator
   * @default false
   */
  exports.prototype['NotifyCreator'] = false;
  /**
   * @member {Date} LastGeneratedPeriod
   */
  exports.prototype['LastGeneratedPeriod'] = undefined;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


